import { BaseService } from '@core/base/service/base-service'
import { Analytics } from '@core/services/mixpanel'
import { ROUTES } from '@core/config/routing'

type TIntercomSettings = {
    api_base: string
    app_id: string
    name: string
    email: string
    user_id: string
    stance_account_id: string
    created_at?: number
    has_domains: boolean
    has_issues: boolean
}

export const IntercomService = new (class IntercomService extends BaseService {
    constructor() {
        super('intercom.service')
        this.listenToEvents()
    }

    listenToEvents() {
        this.$eventBus.on(
            'summary_loaded',
            ({ user, hasDomains, hasIssues }) => {
                this.initialize(user, hasDomains, hasIssues)
            }
        )

        this.$eventBus.on('app_initialized', ({ user, locationPathname }) => {
            const summaryPage = locationPathname === ROUTES.summary.path
            if (!summaryPage) {
                this.initialize(user, false, false)
            }
        })
    }

    initialize(user: TCurrentUser, hasDomains: boolean, hasIssues: boolean) {
        const settings = {
            api_base: this.envVars.REACT_APP_INTERCOM_API_BASE,
            app_id: this.envVars.REACT_APP_INTERCOM_APP_ID,
            name: `${user.first_name ?? ''} ${user.last_name ?? ''}`,
            email: user.email?.value,
            user_id: user.id,
            stance_account_id: this.accountId,
            has_domains: hasDomains,
            has_issues: hasIssues,
        } as TIntercomSettings

        if (user.created_at) {
            settings.created_at = new Date(user.created_at).getTime()
        }

        window.Intercom('boot', settings)
        // @ts-ignore
        window.Intercom('onShow', () => {
            Analytics.event('SEM::user_clicked_chat')
        })
    }

    sendEvent(event: IntercomEvents, metadata?: any) {
        window.Intercom('trackEvent', event, metadata)
    }
})()
